import {useState} from "react";
import {useTranslation} from "react-i18next";
import {Col} from "@pg-design/grid";
import {flex, pt} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text";

import {MonitoringPricingBox} from "./MonitoringPricingBox";
import {RpClientCheckbox} from "./RpClientCheckbox";
import {SubscriptionBox} from "./SubscriptionBox";

export const MonitoringSubscriptionBox = () => {
    const {t} = useTranslation();
    const [isRpClient, setIsRpClient] = useState<boolean>(false);

    return (
        <SubscriptionBox>
            <Col md={12}>
                <Text variant="headline_3" as="p" align="center">
                    {t("pricing.monitoring_subscription.title")}
                </Text>
                <div css={[flex(), pt(2)]}>
                    <RpClientCheckbox checked={isRpClient} onChange={setIsRpClient} />
                </div>
            </Col>

            <Col sm={4} md={12}>
                <MonitoringPricingBox isRpClient={isRpClient} />
            </Col>
        </SubscriptionBox>
    );
};
